(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["perfume-scent-profile"] && !Shopify.designMode) return;
  try {
    (function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = window.Shopify && window.Shopify.designMode;

  function countUp(el, to, delay) {
    el.textContent = '0';
    setTimeout(function () {
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min((ts - start) / 650, 1);
        el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }, delay);
  }

  function open(card) {
    var panel = card.querySelector('[data-sp-open]');
    if (!panel) return;
    card.setAttribute('data-state', 'open');
    panel.hidden = false;
    setTimeout(function () { fireworks(card); }, 60);
    /* restart CSS animations if re-opened */
    panel.style.animation = 'none'; void panel.offsetWidth; panel.style.animation = '';
    var base = parseFloat(getComputedStyle(panel).getPropertyValue('--t-bf')) || 1.5;
    panel.querySelectorAll('[data-count]').forEach(function (el, i) {
      var to = parseInt(el.getAttribute('data-count'), 10) || 0;
      countUp(el, to, reduced ? 0 : (base * 1000 + 200 + i * 90));
    });
  }

  function close(card) {
    var panel = card.querySelector('[data-sp-open]');
    if (panel) panel.hidden = true;
    card.setAttribute('data-state', 'closed');
    stopFireworks(card);
  }

  /* Diwali firework show every time the card opens: rockets + golden willow rain + anar fountains from the diyas.
     Each open plays the show ONCE (no loop), then every spark is removed. Closing stops and clears it at once. */
  var FX_COLS = ['#D6322B', '#F59E0B', '#2E9B57', '#E8722C', '#7C3AED', '#0EA5E9', '#FFB020', '#FF7A7F'];
  function fxDot(fx, x, y, col, size) {
    var p = document.createElement('i');
    p.className = 'sp-sp'; p.style.left = x + 'px'; p.style.top = y + 'px'; p.style.background = col;
    if (size) { p.style.width = p.style.height = size + 'px'; p.style.margin = (-size / 2) + 'px 0 0 ' + (-size / 2) + 'px'; }
    fx.appendChild(p); return p;
  }
  function fxGone(p) { return function () { if (p.parentNode) p.parentNode.removeChild(p); }; }
  function fxBurst(fx, cx, cy, willow, H) {
    var f = document.createElement('i');
    f.className = 'sp-fl2'; f.style.left = cx + 'px'; f.style.top = cy + 'px'; fx.appendChild(f);
    f.animate([{ transform: 'scale(.3)', opacity: 1 }, { transform: 'scale(2.4)', opacity: 0 }], { duration: 450, easing: 'ease-out' }).onfinish = fxGone(f);
    var main = FX_COLS[Math.floor(Math.random() * FX_COLS.length)], n = willow ? 18 : 22;
    for (var i = 0; i < n; i++) {
      var a = (i / n) * Math.PI * 2 + Math.random() * 0.25, d = (willow ? 40 : 34) + Math.random() * 30;
      var fall = willow ? H * (0.35 + Math.random() * 0.3) : 24;
      var p = fxDot(fx, cx, cy, willow ? (i % 2 ? '#FFD66B' : '#F5B316') : (i % 3 ? main : FX_COLS[Math.floor(Math.random() * FX_COLS.length)]));
      p.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + (Math.cos(a) * d) + 'px,' + (Math.sin(a) * d + 12) + 'px) scale(1)', opacity: 1, offset: willow ? 0.25 : 0.4 },
        { transform: 'translate(' + (Math.cos(a) * d * 1.15) + 'px,' + (Math.sin(a) * d + fall) + 'px) scale(.3)', opacity: 0 }
      ], { duration: willow ? 2300 + Math.random() * 500 : 1000 + Math.random() * 350, easing: 'cubic-bezier(.2,.6,.4,1)' }).onfinish = fxGone(p);
    }
  }
  function fxRocket(fx, x, y, from, willow, H) {
    var r = document.createElement('i');
    r.className = 'sp-rk'; r.style.left = x + 'px'; r.style.top = from + 'px'; fx.appendChild(r);
    r.animate([{ transform: 'translateY(0)' }, { transform: 'translateY(' + (y - from) + 'px)' }], { duration: 700, easing: 'cubic-bezier(.2,.7,.3,1)', fill: 'forwards' })
      .onfinish = function () { fxGone(r)(); if (fx.isConnected) fxBurst(fx, x, y, willow, H); };
  }
  function fxFountain(fx, x, y, h) {
    for (var i = 0; i < 26; i++) {
      (function (i) {
        setTimeout(function () {
          if (!fx.isConnected) return;
          var a = (Math.random() - 0.5) * 1.5, p = fxDot(fx, x, y, i % 2 ? '#FFB020' : '#FF7A3D', 3);
          var dx = Math.sin(a) * h * 0.9, up = -h * (0.6 + Math.random() * 0.5);
          p.animate([
            { transform: 'translate(0,0)', opacity: 1 },
            { transform: 'translate(' + (dx * 0.6) + 'px,' + up + 'px)', opacity: 1, offset: 0.5 },
            { transform: 'translate(' + dx + 'px,' + (up * 0.15) + 'px)', opacity: 0 }
          ], { duration: 850, easing: 'ease-out' }).onfinish = fxGone(p);
        }, i * 45);
      })(i);
    }
  }
  function fireworks(card) {
    if (reduced || !card.animate || card.__spFx) return;
    card.__spFx = true;
    var w = card.clientWidth, h = card.clientHeight;
    var fx = document.createElement('div');
    fx.className = 'sp-fx'; fx.setAttribute('aria-hidden', 'true');
    card.appendChild(fx);
    var foot = card.querySelector('.sp-foot'), by = h - 34;
    if (foot) { var cr = card.getBoundingClientRect(), fr = foot.getBoundingClientRect(); by = fr.top - cr.top + fr.height * 0.45; }
    var big = Math.min(w, 420);
    /* anar fountains from the three diyas */
    [0.3, 0.5, 0.7].forEach(function (k, i) { setTimeout(function () { if (fx.isConnected) fxFountain(fx, k * w, by, Math.min(h * 0.17, 70)); }, 150 + i * 200); });
    /* rockets: [x, burst-y, delay, willow] */
    [[0.2, 0.22, 300, 0], [0.78, 0.13, 650, 1], [0.5, 0.07, 1000, 0], [0.12, 0.34, 1350, 1], [0.9, 0.3, 1650, 0]].forEach(function (s) {
      setTimeout(function () { if (fx.isConnected) fxRocket(fx, s[0] * w, Math.max(30, s[1] * h), by, s[3], Math.min(h, big * 1.2)); }, s[2]);
    });
    card.__spFxEl = fx;
    setTimeout(function () { stopFireworks(card, fx); }, 5200);
  }
  function stopFireworks(card, fx) {
    fx = fx || card.__spFxEl;
    if (fx && fx.parentNode) fx.parentNode.removeChild(fx);
    if (!fx || fx === card.__spFxEl) { card.__spFxEl = null; card.__spFx = false; }
  }

  function play(card) {
    if (card.getAttribute('data-state') !== 'closed') return;
    if (reduced) { open(card); return; }
    card.setAttribute('data-state', 'playing');
    setTimeout(function () { open(card); }, 1500);
  }

  function init() {
    document.querySelectorAll('[data-sp]:not(.sp-init)').forEach(function (card) {
      card.classList.add('sp-init');
      var tap = card.querySelector('[data-sp-tap]');
      if (tap) tap.addEventListener('click', function () { play(card); });
      var rp = card.querySelector('[data-sp-replay]');
      if (rp) rp.addEventListener('click', function () { open(card); });
      var cl = card.querySelector('[data-sp-close]');
      if (cl) cl.addEventListener('click', function () { close(card); });
      if (design) open(card);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  if (design) {
    document.addEventListener('shopify:block:select', function (e) {
      var card = e.target.matches('[data-sp]') ? e.target : e.target.querySelector('[data-sp]');
      if (card) open(card);
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["review"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded",function(){

const trigger=document.querySelector(".units-sold-trigger");

const popup=document.getElementById("soldPopup");

const close=document.querySelector(".sold-popup-close");

if(trigger){

trigger.addEventListener("click",function(){

popup.classList.add("show");

});

}

close.addEventListener("click",function(){

popup.classList.remove("show");

});

popup.addEventListener("click",function(e){

if(e.target===popup){

popup.classList.remove("show");

}

});

});
  } catch(e) { console.error(e); }
})();

})();
